/**
 *
 * @module sessionLocation
 *
 */

import Check from 'check-types';
import Exception from './../exception/entry';
import SessionLocationType from './sessionLocationType';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class SessionLocation
 * @desc Represents the session location data provided by the service.
 * @todo update type to SessionLocationType when configs are updated
 *
 */
export default class SessionLocation {

    /**
     *
     * @param {String} type
     * @param {String} [zipCode='']
     * @param {String} [countryCode='']
     * @param {Number} [designatedMarketArea=null]
     *
     */
    constructor(type, zipCode = '', countryCode = '', designatedMarketArea = null) {

        const errorMessage = {
            ctor: 'SessionLocation(type, zipCode, countryCode, designatedMarketArea)',
            get type() {
                return `${this.ctor} type should be a String with length`;
            }
        };

        nonEmptyString(type, errorMessage.type, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.type = SessionLocationType[type] || SessionLocationType.UNKNOWN;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.zipCode = zipCode;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.countryCode = countryCode;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.designatedMarketArea = designatedMarketArea;

    }

}



// WEBPACK FOOTER //
// ./src/services/session/sessionLocation.js